import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UnsavedChangesNotifierService} from '@application/helper/unsaved-changes-notifier/unsaved-changes-notifier.service';
import {CreelPosition} from '@domain/textile-data/creel/creel-position';
import {MaterialSet} from '@domain/textile-data/textile-data';
import {indexOf, isEqual, isNil, map, size} from 'lodash-es';

@Component({
  selector: 'app-creel-positions',
  templateUrl: './creel-positions.component.html',
  styleUrls: ['./creel-positions.component.scss']
})
export class CreelPositionsComponent {
  @Input() public materialSet: MaterialSet;
  @Input() public canShowErrorForCreelPosition: (creelPositionIndex: number) => boolean;
  @Input() public canEditMaterialSet: boolean;
  @Output() public selectedCreelPositionChanged: EventEmitter<void> = new EventEmitter<void>();
  @Output() public creelPositionHasBeenChanged: EventEmitter<void> = new EventEmitter<void>();

  public constructor(private unsavedChangesNotifierService: UnsavedChangesNotifierService) {}

  public canShowSkeletonView(): boolean {
    return isNil(this.materialSet);
  }

  public hasCreelPositions(): boolean {
    return !isEqual(this.materialSet.getSizeOfCreelPositions(), 0);
  }

  public onDropCreelPosition(event: CdkDragDrop<CreelPosition[]>): void {
    const amountOfCreelPositions = size(this.materialSet.creelPositions);
    const previousIndex = amountOfCreelPositions - 1 - event.previousIndex;
    const currentIndex = amountOfCreelPositions - 1 - event.currentIndex;
    moveItemInArray(this.materialSet.creelPositions, previousIndex, currentIndex);
    this.unsavedChangesNotifierService.notifyChangesToOthers();
  }

  public deselectAllSelectedCreelPositions(): void {
    map(this.materialSet.creelPositions, (creelPosition: CreelPosition) => (creelPosition.isSelected = false));
  }

  public getActualCreelPositionIndex(creelPosition: CreelPosition): number {
    return indexOf(this.materialSet.creelPositions, creelPosition);
  }
}
